import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OrderService } from "src/app/core/services/order.service";
import { PaymentService } from "src/app/core/services/payment.service";
import { I4goPaymentResponseDTO } from "src/app/shared/models/DTO/I4goPaymentRequest.dto";
import { EGiftTransaction } from "src/app/shared/models/eGift/EGiftTransaction.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import { CCProcessors } from "src/app/shared/models/enums/CCProcessors.enum";
import { ProductUseFunction } from "src/app/shared/models/enums/ProductUseFunction.enum";
import { OOVenue } from "src/app/shared/models/oo-venue";
import { OrderPayment } from "src/app/shared/models/order";

@Component({
	selector: "app-e-gift-checkout",
	templateUrl: "./e-gift-checkout.component.html",
	styleUrls: ["../../gift.style.scss"],
})
export class EGiftCheckoutComponent implements OnInit {
	@Input() eGiftVenue: EGiftVenue;
	@Input() ooVenue: OOVenue;
	@Input() transaction: EGiftTransaction;

	@Output() transactionComplete: EventEmitter<EGiftTransaction> = new EventEmitter<EGiftTransaction>();

	transactionError: string = "";

	constructor(public app: AppService, private focuslink: FocuslinkService, public orderService: OrderService, public paymentService: PaymentService) {}

	ngOnInit(): void {
		if (this.orderService.venueService.ooVenue.ccProcessor === CCProcessors.FOCUSPAYADYEN) {
			this.paymentService.startSession(this.transaction.transactionAmount, this.orderService.activeCheckKey.value);
		}
		this.app.initProduct(this.ooVenue.venueKey, "egift", ProductUseFunction.CARTITEM, this.app.useKey);
	}

	async paymentComplete(payment: I4goPaymentResponseDTO) {
		this.app.loading(true);
		const orderPayment: OrderPayment = I4goPaymentResponseDTO.toOrderPayment(payment, 0);

		switch (this.orderService.venueService.ooVenue.ccProcessor) {
			case CCProcessors.FOCUSPAYADYEN: {
				this.processFocusPayPayment(orderPayment);
				break;
			}
			case CCProcessors.FOCUSPAYDATACAP: {
				this.processThirdPartyPayment(payment, orderPayment);
				break;
			}
			default: {
				this.processThirdPartyPayment(payment, orderPayment);
				break;
			}
		}
	}

	async processFocusPayPayment(orderPayment: OrderPayment) {
		orderPayment.focusPay = true;
		this.transaction.orderPayment = orderPayment;
		this.transactionComplete.emit(this.transaction);
	}

	async processThirdPartyPayment(payment: I4goPaymentResponseDTO, orderPayment: OrderPayment) {
		if (!payment.securityCode && payment.streetAddress && !isNaN(+payment.streetAddress)) {
			orderPayment.securityCode = payment.streetAddress;
		}
		if (!orderPayment.firstName || orderPayment.lastName) {
			orderPayment.firstName = this.transaction.purchaserFirstName;
			orderPayment.lastName = this.transaction.purchaserLastName;
		}
		this.transaction.purchaserZipcode = orderPayment.postalCode;

		let paymentAuthorization;
		try {
			paymentAuthorization = await this.focuslink.paymentAuth(this.eGiftVenue.venueKey, orderPayment);

			switch (this.ooVenue.ccProcessor) {
				case CCProcessors.SHIFT4:
					if (paymentAuthorization) this.transaction.invoice = paymentAuthorization.transId;
					orderPayment.invoiceNumber = paymentAuthorization.transId;
					this.transaction.token = orderPayment.token;
					break;
				case CCProcessors.FOCUSPAYDATACAP:
					orderPayment.pspReference = paymentAuthorization.RefNo;
					orderPayment.token = paymentAuthorization.Token;
					orderPayment.authCode = paymentAuthorization.AuthCode;
					break;
			}

			orderPayment.authorization = JSON.stringify(paymentAuthorization);
			this.transaction.orderPayment = orderPayment;
			this.transactionComplete.emit(this.transaction);
			this.app.loading(false);
		} catch (error) {
			this.transactionError = error.error.error;

			this.app.loading(false);
			this.app.msgSvc.add({
				severity: "error",
				summary: error.error.error,
			});
		}
	}
}
